import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import './Newsfeed.css';
import { Article } from '../../types/shared/Article';
import withAsyncImport from '../../withAsyncImport';

const HomeVariant = withAsyncImport(() => import('./variants/HomeVariant'));
const NewsPressVariant = withAsyncImport(() => import('./variants/NewsPressVariant'));
const HomeRedesign = withAsyncImport(() => import('./variants/HomeRedesign'));
const NewsPressHeroVariant = withAsyncImport(() => import('./variants/NewsPressHeroVariant'));

type TNewsPressVariant = | 'home' | 'newsPress' | 'newsPressRedesign' | 'homeRedesign' | 'newsPressHero';

interface INewsfeedProps extends MappedComponentProperties {
    title?: string;
    variant?: TNewsPressVariant
    latestNewsArticle?: boolean;
    imageUrl?: string;
    imageAltText?: string;
    releaseTitle?: string;
    releaseText?: string;
    releaseButtonLabel?: string;
    releaseButtonLink?: string;
    openLinkNewTab?: boolean;
    currentPage?: number;
    totalPages?: number;
    prevPageUrl?: string;
    nextPageUrl?: string;
    articles?: Article[];
    pressArticles?: Article[];
    backgroundColor?: 'white'|'light-grey'| 'light-blue'| 'blue'| 'purple';
    viewAllNewsBtnText?: string;
    viewAllNewsBtnUrl?: string;
    titleSize?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span";
    showHr?: boolean;
    titleVariant?: 'center'| 'left';
    subtitle?: string;
    heading?: string;

    articlesToShow?: number;
    isDarkMode?: boolean;
}

export const NewsfeedEditConfig = {
    emptyLabel: 'Newsfeed',
    isEmpty: (props: PropsWithChildren<INewsfeedProps>) => {
        return !props || !props.articles || !props.articles.length;
    },
};

const Newsfeed = (props: PropsWithChildren<INewsfeedProps>): JSX.Element => {
    let pressArticleInfo: Article = null;

    function findNewestArticle() {
        pressArticleInfo = props.pressArticles[0];
        props.pressArticles.forEach(article => {
            if (article.date > pressArticleInfo.date) {
                pressArticleInfo = article;
            }
        });
    }

    return (
            <div id='newsfeed' className={`NewsfeedComponent ${props.variant !== 'homeRedesign' ? 'my-4': ''}`}>
                {props.latestNewsArticle && props.variant === 'home' && props?.pressArticles && <>
                {findNewestArticle()}
                <HomeVariant
                    imageUrl={pressArticleInfo.imagePath}
                    imageAltText={pressArticleInfo.imageAlt}
                    releaseTitle={'<h3>' + pressArticleInfo.title + '</h3>'}
                    releaseText={pressArticleInfo.previewDescription}
                    releaseButtonLabel={props.releaseButtonLabel}
                    releaseButtonLink={pressArticleInfo.pagePath + '.html'}
                    openLinkNewTab={props.openLinkNewTab}
                />
            </>}

            {props.variant === 'home' && !props.latestNewsArticle && (
                <HomeVariant {...props} />
            )}


            {props.latestNewsArticle && props.variant === 'homeRedesign' && props?.pressArticles && <>
                {findNewestArticle()}
                <HomeRedesign
                    title={props.title}
                    subtitle={props.subtitle}
                    titleSize={props.titleSize}
                    titleVariant={props.titleVariant}
                    showHr={props.showHr}
                    imageUrl={pressArticleInfo.imagePath}
                    imageAltText={pressArticleInfo.imageAlt}
                    releaseTitle={'<h3>' + pressArticleInfo.title + '</h3>'}
                    releaseText={pressArticleInfo.previewDescription}
                    releaseButtonLabel={props.releaseButtonLabel}
                    releaseButtonLink={pressArticleInfo.pagePath + '.html'}
                    openLinkNewTab={props.openLinkNewTab}
                    date={pressArticleInfo.date}
                    backgroundColor={props.backgroundColor}
                    viewAllNewsBtnText={props.viewAllNewsBtnText}
                    viewAllNewsBtnUrl={props.viewAllNewsBtnUrl}
                />
            </>}

            {props.variant === 'homeRedesign' && !props.latestNewsArticle && (
                <HomeRedesign {...props} />
            )}

            {(props.variant === 'newsPress' || props.variant === 'newsPressRedesign') && (
                <NewsPressVariant {...props} />
            )}

            {props.variant === 'newsPressHero' && (
                <NewsPressHeroVariant {...props} />
            )}
        </div>
    );
};

export default Newsfeed;